/**
 * Copyright 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const EMAIL_MSG_PREVIEW_MODAL_TITLE = "Sample Message";

export const SLACK_MSG_PREVIEW_MODAL_TITLE = "Slack Sample Message";

export const SERVICENOW_MSG_PREVIEW_MODAL_TITLE = "ServiceNow Sample Message";
